import { createContext } from "react";

export const ACDMContext = createContext(null);
